import { RESET_DASHBOARD_PART_DATA, UPDATE_DASHBOARD_PART_DATA } from '../actions/DashboardActions';

const initialState = {
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DASHBOARD_PART_DATA:
      return {
        data: {
          [action.payload.id]: action.payload.data,
        },
      };

    case RESET_DASHBOARD_PART_DATA:
      return initialState;

    default:
      return state;
  }
};
